import { AuthData, SessionData, LoginData } from "../types/global";
import packageJson from "../../package.json";
import { devLog, devError } from "./devLog";

const REGISTRY_URL = "https://test.registry.muzaic.ai";
const VERSIONS_SUFFIX = "/api/versions/external-auth";
const AUTH_SUFFIX = "/auth/external";
const RETRIEVE_SUFFIX = "/link/resolve"
const ME_SUFFIX = "/me"

/**
 * Fetches the correct backend environment URL based on the app version
 */
export const fetchEnvironment = async (): Promise<string> => {
  const params = {
    platform_name: "canva",
    version: '3.1.0',
  };

  const url = new URL(REGISTRY_URL + VERSIONS_SUFFIX);
  url.search = new URLSearchParams(params).toString();

  const response = await fetch(url, {
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch environment: ${response.status}`);
  }

  const data = await response.json();
  return data.data.url;
};

export const retrieveSession = async (
  session: string
): Promise<SessionData> => {
  try {
    const environmentPrefix = await fetchEnvironment();
    const response = await fetch(environmentPrefix + RETRIEVE_SUFFIX + `?session=${session}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const sessionData: SessionData = await response.json();
    return sessionData
  } catch (error) {
    devError("[Auth] Retrieve failed:", error);
    throw error;
  }
}

export const loginCanvaUser = async (
  token: string,
  locale: string
): Promise<LoginData> => {
  try {
    // Fetch the correct backend environment URL based on app version
    const environmentPrefix = await fetchEnvironment();
    const jsonData = JSON.stringify({ locale: locale, frontend: "canva" });
    const me_response = await fetch(environmentPrefix + ME_SUFFIX, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: jsonData,
    });
    if (!me_response.ok) {
      throw new Error(`HTTP error! status: ${me_response.status}`);
    }
    const me_data = await me_response.json();
    devLog("[Auth] User profile loaded", me_data);

    return { 
      token,
      authData: null,
      meResponse: me_data
    };
  } catch (error) {
    devError("[Auth] Login failed:", error);
    throw error;
  }
    // FIXME: when auth backend is fixed use proper authorization
    /*

        let jsonData = JSON.stringify({
      locale: locale,
      provider: "canva",
      token: token,
    });

    const response = await fetch(environmentPrefix + AUTH_SUFFIX, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: jsonData,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const authData: AuthData = await response.json();
    authData.expiresAt = Date.now() + authData.expiresIn * 1000;

    devLog(
      "[Auth] Initial auth response - bootstrapToken:",
      authData.bootstrapToken ? "present" : "MISSING"
    );

    jsonData = JSON.stringify({ locale: locale, frontend: "canva" });
    const me_response = await fetch(authData.urls.me, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authData.accessToken}`,
        "Content-Type": "application/json",
      },
      body: jsonData,
    });
    if (!me_response.ok) {
      throw new Error(`HTTP error! status: ${me_response.status}`);
    }
    const me_data = await me_response.json();
    devLog("[Auth] User profile loaded");

    return { 
      authData,
      meResponse: me_data
    };
  } catch (error) {
    devError("[Auth] Login failed:", error);
    throw error;
  }
    */
};
